import { render } from "./StatusTag.vue?vue&type=template&id=7502d708&scoped=true"
import script from "./StatusTag.vue?vue&type=script&lang=js"
export * from "./StatusTag.vue?vue&type=script&lang=js"

import "./StatusTag.vue?vue&type=style&index=0&id=7502d708&lang=sass&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7502d708"]])

export default __exports__